<!-- 医疗案例 -->
<template>
  <div class="case">
    <h4 class="current">您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 医院绩效管理系统</h4>
    <div class="article">
      <h5>医院绩效管理系统</h5>
      <h4 class="smalltit">产品简介</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;绩效管理是现代医院管理的重要方法和科学的管理工具。良好的绩效管理，有助于带动全院职工的工作积极性，有助于提高工作效率、提高医疗质量、改善服务水平、降低运营成本，全面提升医院的精细化管理水平。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;绩效管理过程，是院内各级管理者和医务工作者为了达到医院的战略发展目标，共同参与绩效计划制定、绩效辅导沟通、绩效考核评价、绩效结果应用、绩效目标提升等一系列环节，并持续循环改进、提升的过程。
        <br />
        <img src="@/assets/yiliao1-1.jpg" />

        <span class="boldblack">覆盖了医院绩效管理工作“PDCA”循环的全过程，包括如下功能:</span>
      </p>
      <div class="soncon">
        <p style="margin-left: 0">
          &nbsp;&nbsp;&nbsp;&nbsp;1、系统具有建立核算科室、核算岗位，设置岗位系数、设置岗位职责，进行人员的调科调岗管理、考勤记录等基础数据<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;管理功能；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;2、针对医、护、技、药、管不同岗位，可以设置不同的核算方法、核算参数。系统可以灵活支撑服务人次法，服务项目法
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（RBRVS）、平衡计分卡（BSC）、DRGs等流行的绩效工资核算方法；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;3、系统支持为科室内部二次分配提供分配公式和表单，规范科室内部二次分配，防止出现科室内部“大锅饭”现象。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;并且可灵活支撑各科室的特色分配规则。<br />
          &nbsp;&nbsp;&nbsp;&nbsp;4、支持从工作量、工作效率、质量、安全、患者满意度、内部管理等多个维度制定考核KPI及分数占比。支持平衡计分卡
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（BSC）、综合目标管理法、360度考核、关键事件考核等多种管理考核工具的。支持正向比例法、加分法、<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;减分法、区间法等多种KPI评分公式；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;5、基于工作流的绩效核算过程管理——参与核算的各个岗位、各个环节自动流转。每到一个环节，可以自动按照设置的
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方案进行计算，责任人负责检查、提交数据；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;6、绩效工资核算界面仿EXCEL表格，降低学习成本和操作难度； <br />
          &nbsp;&nbsp;&nbsp;&nbsp;7、支持科室成本、收入的归集、分摊，实现成本控制考核的管理。支持自动采集、excel导入、手工录入各项成本，并
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;进行自动归集与分摊；<br />
          &nbsp;&nbsp;&nbsp;&nbsp;8、提供数据统计分析工具，可以针对管理考核结果、绩效核算结果、成本收入数据等数据，进行查询与分析。
          <br />
        </p>
      </div>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过绩效管理系统的实施，可以促进全院绩效管理工作的规范化、标准化、自动化，强有力的支撑绩效方案的落地。从而极大的提高全院的管理效率，提升全院的执行力，助力医院走向精细化管理的飞速发展之路！
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
